import { fetchWithToken } from "../interceptors/fetchInterceptor";

import Cookies from "js-cookie";

import {
  setCheckStatus,
  setInputsForGimsSections,
  setInputsForIssuanceCertificates,
  setOblast,
} from "../components/GeneralComponents/SearchBlock/inputsHeaders";
import { setDocOptionsFromDictionaries } from "../components/AdministrativeProcedures/commonComponents/infoRepresentPersonIssuingCertificates/optionsInfoRepresentPersonIssuingCertificates";
import {
  setDocOptionsAppKnowledgeVerificationFromDictionaries,
  setTrainingDocOptionsFromDictionaries,
} from "../components/knowledgeTestComponents/appKnowledgeVerification/optionsAppKnowledgeVerification";

import {
  DELETE_USER_INFO,
  GET_ALL_AUDIT_SECURITY_EVENTS,
  GET_ALL_BILL_STATUS,
  GET_ALL_BOAT_TYPES,
  GET_ALL_COUNTRIES,
  GET_ALL_IDENTIFICATION_DOCUMENTS,
  GET_ALL_INF_PAYMENT_AP,
  GET_ALL_KINDS_BOATS,
  GET_ALL_OBLAST,
  GET_ALL_PAID_PROC_TYPES,
  GET_ALL_TRAINING_ORGANIZATIONS,
  GET_APP_REG_STATUS_LIBRARY,
  GET_AUDIT_OBJECT,
  GET_BOAT_BODY_MATERIAL_ALL,
  GET_DATA_BY_SEARCH_PARAMS_BASES_BUILDING,
  GET_DATA_BY_SEARCH_PARAMS_BOATS_REG,
  GET_DATA_BY_SEARCH_PARAMS_LICENSE,
  GET_DATA_BY_SEARCH_PARAMS_TRANSPORT_ACCIDENTS,
  GET_DICTIONARY_GIMS_SECTIONS,
  GET_DICTIONARY_NSI_CHECK_STATUS,
  GET_DICTIONARY_OWNER_TYPE,
  GET_DICTIONARY_STATUS_ISSUANCE_CERTIFICATES,
  GET_ENGINE_TYPES_ALL,
  GET_GIMS_DEPARTMENT_ALL,
  GET_GIMS_SUB_LEVELS,
  GET_GIMS_USER_POSITIONS_ALL,
  GET_LOCALITY_CATEGORY_ALL,
  GET_MED_CONDITIONS_ALL,
  GET_NSI_AP,
  GET_PAGINATION_DATA_BY_SEARCH_PARAMS_BOAT,
  GET_PAYMENT_DETAILS_ALL,
  GET_PREPARATION_PROGRAMS_ALL,
  GET_RANGE_MS_ALL,
  GET_ROLES_ALL,
  GET_SWIMMING_DIFFICULTY_CATEGORY_ALL,
  GET_TRAINING_DOC_TYPES_ALL,
  GET_TRAINING_EXAM_TYPES_ALL,
  GET_TRAINING_PROGRAM_LIBRARY,
  GET_USERS_LIBRARY,
  GET_VALID_TYPES_LIBRARY,
  GET_VALID_ZONES_LIBRARY,
  NEW_GET_DICTIONARY_NSI_CHECK_STATUS,
  SET_INSPECTION_TECHNICAL_CONDITION_BASES,
  SET_LOGBOOK_ADMINISTRATIVE_PROCEDURES,
  SET_SEARCH_PARAMS_APP_KNOWLEDGE_VERIFICATION,
  SET_SEARCH_PARAMS_APPLICANT_SEARCH,
  SET_SEARCH_PARAMS_APPLICATION_TRAINING,
  SET_SEARCH_PARAMS_BASES_BUILDING,
  SET_SEARCH_PARAMS_BOATS,
  SET_SEARCH_PARAMS_BOATS_ADMIN_PROC,
  SET_SEARCH_PARAMS_BOATS_DUPLICATE_TICKETS,
  SET_SEARCH_PARAMS_BOATS_REG,
  SET_SEARCH_PARAMS_BOATS_TECH_EXAM,
  SET_SEARCH_PARAMS_DUP_SHIP_TICKET,
  SET_SEARCH_PARAMS_DUPLICATE_CERTIFICATES,
  SET_SEARCH_PARAMS_EXCHANGE_CERTIFICATES,
  SET_SEARCH_PARAMS_EXPULSION_ORDER,
  SET_SEARCH_PARAMS_EXPULSION_ORDER_LOGBOOK,
  SET_SEARCH_PARAMS_ISSUING_CERTIFICATES,
  SET_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD,
  SET_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD_SEARCH_PEOPLE,
  SET_SEARCH_PARAMS_LICENSE,
  SET_SEARCH_PARAMS_PRINT_CERTIFICATES,
  SET_SEARCH_PARAMS_PROVISION_INFORMATION,
  SET_SEARCH_PARAMS_RECORD_TRAINED_USERS,
  SET_SEARCH_PARAMS_RECORD_TRAINED_USERS_LOGBOOK,
  SET_SEARCH_PARAMS_REG_INFORM_CHANGES,
  SET_SEARCH_PARAMS_SEARCH_LISTENER,
  SET_SEARCH_PARAMS_SETTLEMENTS,
  SET_SEARCH_PARAMS_SHIPS_TICKET,
  SET_SEARCH_PARAMS_TECH_EXAM,
  SET_SEARCH_PARAMS_TRANSPORT_ACCIDENTS,
  SET_SORT_STATE_TABLE,
} from "./types";
import {
  API_ALL_OBLAST,
  API_AUDIT_SECURITY_EVENTS,
  API_BILL_STATUS,
  API_BOAT_BODY_MATERIAL_ALL,
  API_ENGINE_TYPES_ALL,
  API_GET_ALL_BOAT_TYPES,
  API_GET_ALL_COUNTRIES,
  API_GET_ALL_IDENTIFICATION_DOCUMENTS,
  API_GET_ALL_KINDS_BOATS,
  API_GET_ALL_TRAINING_ORGANIZATIONS,
  API_GET_APP_REG_STATUS_LIBRARY,
  API_GET_AUDIT_OBJECT,
  API_GET_BASES_BUILDING_LIST_SEARCH,
  API_GET_BOATS_REG_LIST_SEARCH,
  API_GET_GIMS_SECTIONS,
  API_GET_LICENSE_LIST_SEARCH,
  API_GET_NSI_CHECK_STATUS,
  API_GET_OWNER_TYPE,
  API_GET_PAGINATION_BOATS_LIST_SEARCH,
  API_GET_STATUS_ISSUANCE_CERTIFICATES,
  API_GET_TRAINING_PROGRAM_LIBRARY,
  API_GET_TRANSPORT_ACCIDENT_LIST_SEARCH_PAGINATION,
  API_GET_USERS_LIBRARY,
  API_GET_VALID_TYPES_LIBRARY,
  API_GET_VALID_ZONES_LIBRARY,
  API_GIMS_DEPARTMENT_ALL,
  API_GIMS_SUB_LEVELS,
  API_GIMS_USER_POSITIONS_ALL,
  API_INF_PAYMENT_AP,
  API_LOCALITY_CATEGORY,
  API_MED_CONDITIONS_ALL,
  API_NSI_AP,
  API_PAID_PROC_TYPES,
  API_PAYMENT_DETAILS_ALL,
  API_PREPARATION_PROGRAMS_ALL,
  API_RANGE_MS_ALL,
  API_ROLES_ALL,
  API_SWIMMING_DIFFICULTY_CATEGORY_ALL,
  API_TRAINING_DOC_TYPES_ALL,
  API_TRAINING_EXAM_TYPES_ALL,
  API_USER_LOGOUT,
  MAIN_URL,
  PORT,
  PORT_FOR_AUTH,
  PORT_FOR_REPORT,
  PORT_FOR_TRAINING,
} from "../constants/constants";
import { setLoginStatus } from "./loginReduser/actionLogin";

export const setSortState = (data) => {
  return {
    type: SET_SORT_STATE_TABLE,
    data: data,
  };
};
export function setSearchParams(id, value, url) {
  url = new URL(url).pathname.slice(1);

  let object = { [`${id}`]: value };
  switch (true) {
    case url.includes("smallboatsreg"): {
      return {
        type: SET_SEARCH_PARAMS_BOATS_REG,
        data: object,
      };
    }
    case url.includes("checksAndAudits"): {
      return {
        type: SET_INSPECTION_TECHNICAL_CONDITION_BASES,
        data: object,
      };
    }
    case url.includes("logbookAdministrativeProcedures"): {
      return {
        type: SET_LOGBOOK_ADMINISTRATIVE_PROCEDURES,
        data: object,
      };
    }
    case url === "reginformationchanges": {
      return {
        type: SET_SEARCH_PARAMS_REG_INFORM_CHANGES,
        data: object,
      };
    }

    case url === "reginformationchanges/searchboatcard": {
      return {
        type: SET_SEARCH_PARAMS_BOATS_ADMIN_PROC,
        data: object,
      };
    }
    case url === "dupshipsticket/searchboatcard": {
      return {
        type: SET_SEARCH_PARAMS_BOATS_DUPLICATE_TICKETS,
        data: object,
      };
    }
    case url === "provisioninformation": {
      return {
        type: SET_SEARCH_PARAMS_PROVISION_INFORMATION,
        data: object,
      };
    }
    case url === "dupshipsticket": {
      return {
        type: SET_SEARCH_PARAMS_DUP_SHIP_TICKET,
        data: object,
      };
    }
    case url === "shipsticket": {
      return {
        type: SET_SEARCH_PARAMS_SHIPS_TICKET,
        data: object,
      };
    }
    case url === "transportaccidents": {
      return {
        type: SET_SEARCH_PARAMS_TRANSPORT_ACCIDENTS,
        data: object,
      };
    }
    // case url === "dupshipsticket/searchboatcard": {
    //   return {
    //     type: SET_SEARCH_PARAMS_BOATS_DUP_SHIP_TICKET,
    //     data: object,
    //   };
    // }
    // case url.includes("smallboats"): {
    //   return {
    //     type: SET_SEARCH_PARAMS_BOATS,
    //     data: object,
    //   };
    // }
    case url === "certificates": {
      return {
        type: SET_SEARCH_PARAMS_LICENSE,
        data: object,
      };
    }
    case url.includes("basesbuilding"): {
      return {
        type: SET_SEARCH_PARAMS_BASES_BUILDING,
        data: object,
      };
    }
    case url === "techexamination": {
      return {
        type: SET_SEARCH_PARAMS_TECH_EXAM,
        data: object,
      };
    }
    case url === "techexamination/searchboatcard": {
      return {
        type: SET_SEARCH_PARAMS_BOATS_TECH_EXAM,
        data: object,
      };
    }
    case url === "applicationfortraining": {
      return {
        type: SET_SEARCH_PARAMS_APPLICATION_TRAINING,
        data: object,
      };
    }
    case url === "listenerTracking": {
      return {
        type: SET_SEARCH_PARAMS_EXPULSION_ORDER,
        data: object,
      };
    }
    case url === "listenerTracking/add/searchListener": {
      return {
        type: SET_SEARCH_PARAMS_SEARCH_LISTENER,
        data: object,
      };
    }
    case url === "registeroftrainees": {
      return {
        type: SET_SEARCH_PARAMS_EXPULSION_ORDER_LOGBOOK,
        data: object,
      };
    }
    case url === "record-trained-users": {
      return {
        type: SET_SEARCH_PARAMS_RECORD_TRAINED_USERS,
        data: object,
      };
    }
    case url === "record-trained-user-logbook": {
      return {
        type: SET_SEARCH_PARAMS_RECORD_TRAINED_USERS_LOGBOOK,
        data: object,
      };
    }
    case url === "app-knowledge-verification": {
      return {
        type: SET_SEARCH_PARAMS_APP_KNOWLEDGE_VERIFICATION,
        data: object,
      };
    }
    case url === "issuing-certificates": {
      return {
        type: SET_SEARCH_PARAMS_ISSUING_CERTIFICATES,
        data: object,
      };
    }
    case url === "issuing-certificates/applicant-search": {
      return {
        type: SET_SEARCH_PARAMS_APPLICANT_SEARCH,
        data: object,
      };
    }
    case url === "knoweledge-test-record": {
      return {
        type: SET_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD,
        data: object,
      };
    }
    case url === "knoweledge-test-record/add/searchPeople": {
      return {
        type: SET_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD_SEARCH_PEOPLE,
        data: object,
      };
    }
    case url === "print-certificates": {
      return {
        type: SET_SEARCH_PARAMS_PRINT_CERTIFICATES,
        data: object,
      };
    }
    case url === "exchange-certificates": {
      return {
        type: SET_SEARCH_PARAMS_EXCHANGE_CERTIFICATES,
        data: object,
      };
    }
    case url === "maintainingDirectories/settlements": {
      return {
        type: SET_SEARCH_PARAMS_SETTLEMENTS,
        data: object,
      };
    }
    case url === "duplicate-certificates": {
      return {
        type: SET_SEARCH_PARAMS_DUPLICATE_CERTIFICATES,
        data: object,
      };
    }
    default:
      break;
  }
}

export function getDataBoatsBySearchParams(params, page) {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT + API_GET_PAGINATION_BOATS_LIST_SEARCH + "page=" + page + "&size=10",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      },
    );
    const data = await response.json();

    for (let item of data.content) {
      item.id = item.cardid;
      item.isDanger = item.arrestOrLimit;
      if (item.ownerSurname && item.ownerName) {
        const owner = `${item.ownerSurname} ${item.ownerName} ${item.ownerMidname || ""}`;
        item["owner"] = owner;
      }
    }

    dispatch({
      type: GET_PAGINATION_DATA_BY_SEARCH_PARAMS_BOAT,
      data: data,
    });
  };
}

export function getDataCertificatesBySearchParams(params, page) {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT + API_GET_LICENSE_LIST_SEARCH + "page=" + page + "&size=10",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      },
    ).catch((err) => console.log(err));
    if (response.ok) {
      const data = await response.json();
      for (let item of data.content) {
        const fio = `${item.surname} ${item.name} ${item.midname || ""}`;
        item.id = item.licenseId;
        item["fio"] = fio;
        item.birthDate = !!item.birthDate ? new Date(item.birthDate).toLocaleDateString() : "";
        item.licenseDate = !!item.licenseDate ? new Date(item.licenseDate).toLocaleDateString() : "";
        item.licenseDateEnd = !!item.licenseDateEnd ? new Date(item.licenseDateEnd).toLocaleDateString() : "";
        item.isDanger = item.arrestOrLimit;
      }
      const jsonData = data;
      dispatch({
        type: GET_DATA_BY_SEARCH_PARAMS_LICENSE,
        data: jsonData,
      });
    }
  };
}

export function getDataBasesBuildingBySearchParams(params, page) {
  const checkMeaning = (property) => (property ? property : "");

  return async (dispatch) => {
    let queryParams = "";
    switch (true) {
      case Boolean(params.startDate) && Boolean(params.endDate):
        queryParams = `&startDate=${params.startDate}&endDate=${params.endDate}`;
        break;
      case Boolean(params.startDate):
        queryParams = `&startDate=${params.startDate}`;
        break;
      case Boolean(params.endDate):
        queryParams = `&endDate=${params.endDate}`;
        break;
      default:
        queryParams = "";
    }
    const response = await fetchWithToken(
      MAIN_URL + PORT + API_GET_BASES_BUILDING_LIST_SEARCH + "page=" + page + "&size=10&" + queryParams,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      },
    ).catch((err) => console.log(err));
    if (response.ok) {
      const data = await response.json();

      data.content.forEach((base) => {
        base.id = base.parkId;
        base.ownerLeName = base.ownerLeName;
        base.ownerContact = checkMeaning(base.ownerAddress) + " тел: " + checkMeaning(base.ownerPhone);
        base.ownerUnp = checkMeaning(base.ownerUnp);
        base.baseContact =
          checkMeaning(base.location) +
          " тел1: " +
          checkMeaning(base.phone1) +
          " тел2: " +
          checkMeaning(base.phone2);
        base.responData =
          checkMeaning(base.responPosition) +
          " " +
          checkMeaning(base.responFio) +
          " приказ № " +
          checkMeaning(base.responDocnum) +
          " от " +
          checkMeaning(!!base.responDocdate ? new Date(base.responDocdate).toLocaleDateString() : "");
        base.checkDate = checkMeaning(!!base.checkDate ? new Date(base.checkDate).toLocaleDateString() : "");
        base.statusName = checkMeaning(base.statusName);
        base.sectionName = checkMeaning(base.sectionName);
        base.note = checkMeaning(base.note);
        return base;
      });

      dispatch({
        type: GET_DATA_BY_SEARCH_PARAMS_BASES_BUILDING,
        data: data,
      });
    }
  };
}

export function getDataBoatsRegBySearchParams(params, page) {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT + API_GET_BOATS_REG_LIST_SEARCH + "page=" + page + "&size=10",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      },
    ).catch((err) => console.log(err));
    if (response.ok) {
      const data = await response.json();
      const validData = data.content;
      for (let item of validData) {
        item["fio"] = `${item.surname ? item.surname : ""} ${item.name ? item.name : ""} ${
          item.midname ? item.midname : ""
        }`;
        if (item.operDate) {
          item.operDate = item.operDate.split("-").reverse().join(".");
        }
      }
      dispatch({
        type: GET_DATA_BY_SEARCH_PARAMS_BOATS_REG,
        data: { ...data, content: validData },
      });
    }
  };
}

export function getDictionaryGimsSections() {
  return async (dispatch) => {
    const request = await fetchWithToken(MAIN_URL + PORT + API_GET_GIMS_SECTIONS);
    const response = await request.json();
    const dataValid = response.map((item) => {
      return {
        ...item,
        value: item.sctId,
        label: item.sctName,
        key: "section",
        id: item.sctId,
      };
    });
    dispatch({
      type: GET_DICTIONARY_GIMS_SECTIONS,
      data: dataValid,
    });
    setInputsForGimsSections(dataValid);
  };
}
export function getStatusForIssuanceCertificates() {
  return async (dispatch) => {
    const request = await fetchWithToken(MAIN_URL + PORT + API_GET_STATUS_ISSUANCE_CERTIFICATES);
    const response = await request.json();
    const dataValid = response.map((item) => {
      return {
        value: item.id,
        label: item.name,
        key: "status",
      };
    });
    dispatch({
      type: GET_DICTIONARY_STATUS_ISSUANCE_CERTIFICATES,
      data: dataValid,
    });
    setInputsForIssuanceCertificates(dataValid);
  };
}

export function getDictionaryOwnerType() {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT + API_GET_OWNER_TYPE);
    dispatch({
      type: GET_DICTIONARY_OWNER_TYPE,
      data: await response.json(),
    });
  };
}
export function getDictionaryNsiCheckStatus() {
  return async (dispatch) => {
    const request = await fetchWithToken(MAIN_URL + PORT + API_GET_NSI_CHECK_STATUS);
    const data = await request.json();
    const dataValid = data.map((item) => {
      return {
        value: item.statusId,
        label: item.statusName,
        key: "checkStatus",
      };
    });

    dispatch({
      type: GET_DICTIONARY_NSI_CHECK_STATUS,
      data: dataValid,
    });
    dispatch({
      type: NEW_GET_DICTIONARY_NSI_CHECK_STATUS,
      data: dataValid,
    });
    setCheckStatus(dataValid);
  };
}

export function getUsersLibrary() {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT + API_GET_USERS_LIBRARY);
    const data = await response.json();

    const dataValid = data.map((item) => {
      return {
        ...item,
        value: item.userid,
        label: item.name,
        id: item.userid,
        key: "user",
      };
    });

    dispatch({
      type: GET_USERS_LIBRARY,
      data: dataValid,
    });
  };
}

export function getApplicationRegLibrary() {
  return async (dispatch) => {
    try {
      const url = MAIN_URL + PORT + API_GET_APP_REG_STATUS_LIBRARY;
      const response = await fetchWithToken(url);

      dispatch({
        type: GET_APP_REG_STATUS_LIBRARY,
        data: await response.json(),
      });
    } catch (error) {
      console.error("Request error:", error);
    }
  };
}

export function getTrainingProgramLibrary() {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_TRAINING + API_GET_TRAINING_PROGRAM_LIBRARY);

    dispatch({
      type: GET_TRAINING_PROGRAM_LIBRARY,
      data: await response.json(),
    });
  };
}
export function getAuditObject() {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_GET_AUDIT_OBJECT);
    dispatch({
      type: GET_AUDIT_OBJECT,
      data: await response.json(),
    });
  };
}
export function getValidZonesLibrary() {
  return async (dispatch) => {
    try {
      const url = MAIN_URL + PORT + API_GET_VALID_ZONES_LIBRARY;
      const response = await fetchWithToken(url);
      // const validLib = await response.map(item => {
      //   return {
      //     value: item.id,
      //     label: item.id
      //   }
      // })
      dispatch({
        type: GET_VALID_ZONES_LIBRARY,
        data: await response.json(),
      });
    } catch (error) {
      console.error("Request error:", error);
    }
  };
}

export function getValidTypesLibrary() {
  return async (dispatch) => {
    try {
      const url = MAIN_URL + PORT + API_GET_VALID_TYPES_LIBRARY;
      const response = await fetchWithToken(url);

      dispatch({
        type: GET_VALID_TYPES_LIBRARY,
        data: await response.json(),
      });
    } catch (error) {
      console.error("Request error:", error);
    }
  };
}

export function getDataTransportAccidentBySearchParams(params, page) {
  const queryParams = Object.entries(params)
    .map((item) => {
      if (item[1] !== "" && item[1] !== 0) {
        return `${item[0]}=${item[1]}`;
      }
    })
    .filter((item) => item !== undefined)
    .join("&");
  return async (dispatch) => {
    const request = await fetchWithToken(
      MAIN_URL +
        PORT_FOR_REPORT +
        API_GET_TRANSPORT_ACCIDENT_LIST_SEARCH_PAGINATION +
        "page=" +
        page +
        "&size=10&" +
        queryParams,
    );
    const response = await request.json();
    for (let item of response.content) {
      if (!!item.section && item.section !== null) {
        item["sctName"] = item.section.sctName;
      }
      if (!!item.incidentDate && item.incidentDate !== null) {
        item["incidentDate"] = item.incidentDate.slice(0, 10).split("-").reverse().join(".");
      }

      if (item.ownerSurname && item.ownerName && item.ownerMidname) {
        const owner = `${item.ownerSurname} ${item.ownerName} ${item.ownerMidname}`;
        item["owner"] = owner;
      } else {
        item["owner"] = item?.ownerLename;
      }
      if (!!item.incidentType && item.incidentType !== null) {
        item["incidentType"] = item.incidentType === 1 ? "Авария" : "Инцидент";
      }
      if (item.incidentStatus) {
        item["incidentStatus"] = item.incidentStatus.statusName;
      }
      item["deadTotal"] = item.deadAdult + item.deadChildren;
    }

    dispatch({
      type: GET_DATA_BY_SEARCH_PARAMS_TRANSPORT_ACCIDENTS,
      data: response,
    });
  };
}

export function getGimsDepartmentAll() {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_GIMS_DEPARTMENT_ALL);
    if (response.status === 200) {
      const data = await response.json();

      const dataWithId = data.map((item, index) => ({
        ...item,
        label: item.depName,
        key: "department",
        id: item.depId,
        value: item.depId,
      }));

      dispatch({
        type: GET_GIMS_DEPARTMENT_ALL,
        data: dataWithId,
      });
    }
  };
}
export const getAllTrainingOrganizations = () => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_TRAINING + API_GET_ALL_TRAINING_ORGANIZATIONS);
    const data = await response.json();

    const dataValid = data.map((item) => {
      return {
        ...item,
        value: item.id,
        label: item.name,
        key: "trainingOrg",
      };
    });

    dispatch({
      type: GET_ALL_TRAINING_ORGANIZATIONS,
      data: dataValid,
    });
  };
};

export const getAllCountries = () => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_TRAINING + API_GET_ALL_COUNTRIES);
    const data = await response.json();

    const dataValid = data.map((item) => {
      return {
        ...item,
        value: item.countryId,
        label: item.countryName,
        key: "country",
      };
    });

    dispatch({
      type: GET_ALL_COUNTRIES,
      data: dataValid,
    });
  };
};

export const getAllOblast = () => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT + API_ALL_OBLAST);

    const data = await response.json();

    const dataValid = data.map((item) => {
      return {
        ...item,
        value: item.id,
        label: item.name2,
        key: "oblast",
      };
    });
    setOblast(dataValid);

    dispatch({
      type: GET_ALL_OBLAST,
      data: dataValid,
    });
  };
};

export const getAllGimsUserPositions = () => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_GIMS_USER_POSITIONS_ALL);

    const data = await response.json();

    const dataValid = data.map((item) => {
      return {
        ...item,
        value: item.posId,
        label: item.posName,
        id: String(item.posId),
        key: "position",
      };
    });

    dispatch({
      type: GET_GIMS_USER_POSITIONS_ALL,
      data: dataValid,
    });
  };
};

export const getAllSwimmingDifficultyCategory = () => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_SWIMMING_DIFFICULTY_CATEGORY_ALL);

    const data = await response.json();

    const dataValid = data.map((item) => {
      return {
        ...item,
        value: item.sacCode,
        label: item.sacName,
        id: item.sacCode,
        key: "category",
      };
    });

    dispatch({
      type: GET_SWIMMING_DIFFICULTY_CATEGORY_ALL,
      data: dataValid,
    });
  };
};

export const getAllPreparationPrograms = () => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_PREPARATION_PROGRAMS_ALL);

    const data = await response.json();

    const dataValid = data.map((item) => {
      return {
        ...item,
        value: item.id,
        label: item.sign,
        key: "program",
      };
    });

    dispatch({
      type: GET_PREPARATION_PROGRAMS_ALL,
      data: dataValid,
    });
  };
};

export const getAllPaymentDetails = () => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_PAYMENT_DETAILS_ALL);

    const data = await response.json();

    const dataValid = data.map((item) => {
      return {
        ...item,
        value: item.id,
        label: item.name,
      };
    });

    dispatch({
      type: GET_PAYMENT_DETAILS_ALL,
      data: dataValid,
    });
  };
};
export const getAllIdentificationDocuments = () => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_GET_ALL_IDENTIFICATION_DOCUMENTS);
    if (response.status === 200) {
      const data = await response.json();
      const modifiedDate = data.map((item) => {
        return {
          ...item,
          value: item.id,
          label: item.dtname,
        };
      });
      setDocOptionsFromDictionaries(modifiedDate);
      setDocOptionsAppKnowledgeVerificationFromDictionaries(modifiedDate);
      dispatch({
        type: GET_ALL_IDENTIFICATION_DOCUMENTS,
        data: modifiedDate,
      });
    }
  };
};
export const getAllBoatTypes = () => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_GET_ALL_BOAT_TYPES);
    if (response.status === 200) {
      const data = await response.json();
      const modifiedDate = data.map((item) => {
        return {
          ...item,
          id: item.btcode,
          value: item.btcode,
          label: item.btname,
        };
      });
      dispatch({
        type: GET_ALL_BOAT_TYPES,
        data: modifiedDate,
      });
    }
  };
};

export const getAllLocalityCategory = () => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT + API_LOCALITY_CATEGORY);

    const data = await response.json();

    const dataValid = data.map((item) => {
      return {
        ...item,
        id: item.category,
        value: item.category,
        label: item.namecategoryRu,
      };
    });

    dispatch({
      type: GET_LOCALITY_CATEGORY_ALL,
      data: dataValid,
    });
  };
};

export const getAllMedConditions = () => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_MED_CONDITIONS_ALL);

    const data = await response.json();

    const dataValid = data.map((item) => {
      return {
        ...item,
        value: item.id,
        label: item.name,
      };
    });

    dispatch({
      type: GET_MED_CONDITIONS_ALL,
      data: dataValid,
    });
  };
};

export const getAllRangeMS = () => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_RANGE_MS_ALL);

    const data = await response.json();

    dispatch({
      type: GET_RANGE_MS_ALL,
      data: data,
    });
  };
};

export const getNsiAp = () => {
  return async (dispatch) => {
    const fileRequest = await fetchWithToken(MAIN_URL + PORT + API_NSI_AP);
    if (fileRequest.status === 200) {
      const data = await fileRequest.json();
      const dataValid = data.map((item) => {
        return {
          value: item.code,
          label: item.name,
          key: "apcode",
        };
      });
      dispatch({
        type: GET_NSI_AP,
        data: dataValid,
      });
    }
  };
};

export const getAllTrainingDocTypes = () => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_TRAINING_DOC_TYPES_ALL);

    const data = await response.json();

    const dataValid = data.map((item) => {
      return {
        ...item,
        value: item.id,
        label: item.name,
      };
    });
    setTrainingDocOptionsFromDictionaries(dataValid);
    dispatch({
      type: GET_TRAINING_DOC_TYPES_ALL,
      data: dataValid,
    });
  };
};

export const getAllTrainingExamTypes = () => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_TRAINING + API_TRAINING_EXAM_TYPES_ALL);
    const data = await response.json();

    const dataValid = data.map((item) => {
      return {
        ...item,
        value: item.id,
        label: item.name,
      };
    });

    dispatch({
      type: GET_TRAINING_EXAM_TYPES_ALL,
      data: dataValid,
    });
  };
};

export const getAllKindsBoats = () => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_GET_ALL_KINDS_BOATS);
    if (response.status === 200) {
      const data = await response.json();
      const modifiedDate = data.map((item) => {
        return {
          ...item,
          value: item.id,
          label: item.name,
        };
      });
      dispatch({
        type: GET_ALL_KINDS_BOATS,
        data: modifiedDate,
      });
    }
  };
};

export const getAllEngineTypes = () => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_ENGINE_TYPES_ALL);

    const data = await response.json();

    const dataValid = data.map((item) => {
      return {
        ...item,
        value: item.id,
        label: item.name,
      };
    });

    dispatch({
      type: GET_ENGINE_TYPES_ALL,
      data: dataValid,
    });
  };
};

export const getAllBoatBodyMaterial = () => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_BOAT_BODY_MATERIAL_ALL);

    const data = await response.json();

    const dataValid = data.map((item) => {
      return {
        ...item,
        value: item.matcode,
        label: item.matname,
        id: item.matcode,
      };
    });

    dispatch({
      type: GET_BOAT_BODY_MATERIAL_ALL,
      data: dataValid,
    });
  };
};

export const getAllRoles = () => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_ROLES_ALL);

    const data = await response.json();

    const dataValid = data.map((item) => {
      return {
        ...item,
        value: item.roleid,
        label: item.rolename,
        isRole: false,
        id: item.roleid,
      };
    });

    dispatch({
      type: GET_ROLES_ALL,
      data: dataValid,
    });
  };
};

export const logoutUserById = (id) => {
  return async (dispatch) => {
    dispatch({
      type: DELETE_USER_INFO,
    });

    const response = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_USER_LOGOUT + id, {
      method: "POST",
    });

    if (response.ok) {
      Cookies.remove("refreshToken");
      Cookies.remove("accessToken");
      Cookies.remove("userId");
      Cookies.remove("isAuthorized");
      dispatch(setLoginStatus(false));
    }
  };
};

export const getAllBillStatus = () => {
  return async (dispatch) => {
    const request = await fetchWithToken(MAIN_URL + PORT_FOR_TRAINING + API_BILL_STATUS);
    if (request.status === 200) {
      const data = await request.json();
      const dataValid = data.map((item) => {
        return {
          value: item.id,
          label: item.name,
          key: "billId",
        };
      });
      dispatch({
        type: GET_ALL_BILL_STATUS,
        data: dataValid,
      });
    }
  };
};

export const getAllPaidProcTypes = () => {
  return async (dispatch) => {
    const request = await fetchWithToken(MAIN_URL + PORT + API_PAID_PROC_TYPES);
    if (request.status === 200) {
      const data = await request.json();
      const dataValid = data.map((item) => {
        return {
          value: item.id,
          label: item.name,
          key: "paidProcType",
        };
      });
      dispatch({
        type: GET_ALL_PAID_PROC_TYPES,
        data: dataValid,
      });
    }
  };
};
export const getAllInfPaymentAp = () => {
  return async (dispatch) => {
    const request = await fetchWithToken(MAIN_URL + PORT + API_INF_PAYMENT_AP);
    if (request.status === 200) {
      const data = await request.json();
      dispatch({
        type: GET_ALL_INF_PAYMENT_AP,
        data: data,
      });
    }
  };
};

export const getAllAuditSecurityEvents = () => {
  return async (dispatch) => {
    const request = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_AUDIT_SECURITY_EVENTS);
    if (request.status === 200) {
      const data = await request.json();
      dispatch({
        type: GET_ALL_AUDIT_SECURITY_EVENTS,
        data: data,
      });
    }
  };
};

export const getGimsSubLevels = () => {
  return async (dispatch) => {
    const request = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_GIMS_SUB_LEVELS);
    if (request.status === 200) {
      const data = await request.json();
      dispatch({
        type: GET_GIMS_SUB_LEVELS,
        data: data,
      });
    }
  };
};
